import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { Text } from '@websolutespa/bom-mixer-llm';
import style from './form-recap-success.module.scss';

export const FormRecapSuccess: React.FC = () => {
  const label = useLabel();

  return (
    <div className={getClassNames(style.formRecapSuccess, 'llm__row')}>
      <div className="llm__col --sm-10 --md-8 --lg-6">
        <Text body={label('llm.formRecapSuccess')} />
      </div>
    </div>
  );
};
